import React, { useState } from 'react';
import * as S from './styles';
import amarelo from '../../../front-novo/home/eventos/amarelo.jpg';
import azul from '../../../front-novo/home/eventos/azul.jpg';
import azul2 from '../../../front-novo/home/eventos/azul2.jpg';
import marrom from '../../../front-novo/home/eventos/marrom.jpg';
import vermelho from '../../../front-novo/home/eventos/vermelho.jpg';
import more from '../../../front-novo/home/eventos/more.png';
import previous from '../../../front-novo/home/previous.png';
import next from '../../../front-novo/home/next.png';
import { Link } from 'react-router-dom';

const items = [
  // {
  //   id: 1,
  //   title: 'Escutar o texto',
  //   description: 'Discussão de casos clínicos publicados',
  //   date: '03/07/2024',
  //   image: azul,
  //   cardTheme: 'azul',
  // },
  // {
  //   id: 2,
  //   title: 'VII Seminário Clínico',
  //   description: 'Além do princípio de prazer',
  //   date: '03/07/2024',
  //   image: amarelo,
  //   cardTheme: 'amarelo',
  // },
  // {
  //   id: 3,
  //   title: 'Outro Evento',
  //   description: 'Descrição do evento',
  //   date: '04/07/2024',
  //   image: marrom,
  //   cardTheme: 'marrom',
  // },
  // {
  //   id: 4,
  //   title: 'Outro Evento',
  //   description: 'Descrição do evento',
  //   date: '04/07/2024',
  //   image: vermelho,
  //   cardTheme: 'vermelho',
  // },
  // {
  //   id: 5,
  //   title: 'Outro Evento',
  //   description: 'Descrição do evento',
  //   date: '04/07/2024',
  //   image: azul2,
  //   cardTheme: 'azul',
  // },
  {
    id: 6,
    title: 'I Colóquio Clínico da Travessias',
    description:
      'A cor do inconsciente e a constituição psíquica: clínica, formação e política',
    date: '22/08/2026',
    image: vermelho,
    cardTheme: 'vermelho',
    inscriptionLink:
      'https://www.sympla.com.br/evento/i-coloquio-travessias-a-cor-do-inconsciente-e-a-constituicao-psiquica-clinica-formacao-e-politica/3444547',
    pdfLink:
      'https://travessias.s3.sa-east-1.amazonaws.com/Normas+de+Submiss%C3%A3o+-+I+Col%C3%B3quio+Cl%C3%ADinico+Travessias.pdf',
  },
  // {
  //   id: 7,
  //   title: 'Outro Evento',
  //   description: 'Descrição do evento',
  //   date: '04/07/2024',
  //   image: vermelho,
  //   cardTheme: 'vermelho',
  // },
];

function Carrossel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex(prevIndex =>
      prevIndex === 0 ? items.length - 1 : prevIndex - 1,
    );
  };

  const handleNext = () => {
    setCurrentIndex(prevIndex =>
      prevIndex >= items.length - 2 ? 0 : prevIndex + 2,
    );
  };

  const handleClick = (id: any) => {
    // Função que será chamada quando o botão for clicado
  };
  return (
    <S.CarrosselContainer>
      <S.CarrosselInner
        style={{ transform: `translateX(-${currentIndex * 52}%)` }}
      >
        {items.map(item => (
          <S.CarrosselItem key={item.id}>
            <img src={item.image} alt={item.title} />
            <div>
              <S.CarrosselText className={item.cardTheme}>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <hr />
                <h3>{item.date}</h3>
                <S.SubscribeButtons>
                  <S.SubscribeButton>
                    <h4>
                      {' '}
                      <a
                        href={item.inscriptionLink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Inscreva-se
                      </a>
                    </h4>
                  </S.SubscribeButton>
                  <S.SubscribeButton>
                    <h4>
                      {' '}
                      <a href={item.pdfLink} target="_blank" rel="noreferrer">
                        Instruções para submissão
                      </a>
                    </h4>
                  </S.SubscribeButton>
                </S.SubscribeButtons>

                {/* <div>

                </div> */}
              </S.CarrosselText>
            </div>
          </S.CarrosselItem>
        ))}
      </S.CarrosselInner>
      <S.CarrosselButtons>
        <S.CarrosselButton onClick={handlePrev}>
          {' '}
          {/* <img src={previous} alt="moreButton" /> */}
        </S.CarrosselButton>
        <S.CarrosselButton onClick={handleNext}>
          {' '}
          {/* <img src={next} alt="moreButton" /> */}
        </S.CarrosselButton>
      </S.CarrosselButtons>
    </S.CarrosselContainer>
  );
}

export default Carrossel;
